import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import { atualizarRota, cadastrarRota, excluirRota, obterPermissoesRota, obterRotas, obterRotasPorTextoDeBusca } from "src/services/rotas.service";
import RotaForm from "src/forms/RotaForm";
import { getPermissoes } from "../../services/api-autenticacao.service";

const Rotas = () => {

  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [rotaPermissionsData, setRotaPermissionsData] = useState([]);
  const [msg, setMsg] = useState("");

  const [usersData, setRotasData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const columns = [
    { id: "idRota", label: "ID", field: "idRota" },
    { id: "caminho", label: "Caminho", field: "caminhoFront" },
    { id: "descricao", label: "Descrição", field: "descricao" },
    { id: "ativo", label: "Ativo", field: "ativo" },
    { id: "logAtivo", label: "Logs", field: "logAtivo" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getRotas();
      setLoading(false);
    };

    fetchData();

    const fetchDataPermissao = async () => {
      setLoading(true);
      try {
        const response = await getPermissoes();
        setRotaPermissionsData(response.permissoes);
      } catch (err) {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
      }
      setLoading(false);
    };

    fetchDataPermissao();
  }, [navigate]);

  const getRotas = async () => {
    try {
      const response = await obterRotas();
      var rotas = response.rotas;
      rotas.forEach(rota => {
        const caminhoArr = rota.caminho.split('/')
        rota.caminhoFront = 
          <>
            {
              caminhoArr.map((caminhoPart, idx) => (
                <span key={rota.idRota + '_' + idx + '_caminhoFront'}>
                  {
                    (idx !== 0)
                      ? <><wbr/>/{caminhoPart}</>
                      : <>{caminhoPart}</>
                  }
                </span>
              ))
            }
          </>
      });
      setRotasData(rotas);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterRotasPorTextoDeBusca(event.target.value);
      const rotas = response.rotas;
      rotas.forEach(rota => {
        const caminhoArr = rota.caminho.split('/')
        rota.caminhoFront = 
          <>
            {
              caminhoArr.map((caminhoPart, idx) => (
                <span key={rota.idRota + '_' + idx + '_caminhoFront'}>
                  {
                    (idx !== 0)
                      ? <><wbr/>/{caminhoPart}</>
                      : <>{caminhoPart}</>
                  }
                </span>
              ))
            }
          </>
      });
      setRotasData(rotas);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setRotasData([]);
      } 
      else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      };
    }
    setLoading(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    if (!editRowData.idRota) {
      await cadastrarRota({dadosRota: data.dadosRota})
        .then(async (response) => {
          setMsg(response.mensagem);
          await getRotas();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));
    } else {
      await atualizarRota(editRowData.idRota, {dadosRota: data.dadosRota})
        .then(async (response) => {
          setMsg(response.mensagem);
          await getRotas();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));
    }

    setLoading(false);
  };

  const handleOpenModal = async (rowData) => {
    (rowData.idRota !== undefined)
      ? setEditRowData(rowData)
      : setEditRowData({});

    if (rowData.idRota) {
        const vinculos = await obterPermissoesRota(rowData.idRota);
        setEditRowData({
          vinculos: vinculos.dadosRota.vinculos,
          ...rowData
        });
    } else {
      setEditRowData({
        vinculos: [],
        ...rowData
      });
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <AltRouteIcon fontSize="30px"/>
        }
        headerTitle={"Rotas"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
      />

      <TabelaDinamica
        data={usersData}
        columns={columns}
        loading={loading}
        orderColumn={'idRota'}
        onEditButtonClick={handleOpenModal}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <AltRouteIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idUsuario
                ? "Edição de Rota"
                : "Cadastro de Rota"}
            </h1>
          </div>
        </DialogTitle>
        <RotaForm
          rotaValues={Object.assign({}, editRowData)}
          rotaPermissionData={rotaPermissionsData}
          loading={loading}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        >
        </RotaForm>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Rotas;
